export const SET_MOBISERV_DETAILS = 'SET_MOBISERV_DETAILS'